// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'clock';

export const Component = () => (
  <path d='M20.984 4.016C18.641 1.672 15.828.5 12.5.5 9.172.5 6.36 1.672 4.016 4.016 1.672 6.359.5 9.172.5 12.5c0 3.328 1.172 6.14 3.516 8.484C6.359 23.328 9.172 24.5 12.5 24.5c3.328 0 6.14-1.172 8.484-3.516 2.344-2.343 3.516-5.156 3.516-8.484 0-3.328-1.172-6.14-3.516-8.484Zm-8.483 19.5c-3.047 0-5.672-1.079-7.828-3.235-2.157-2.156-3.235-4.735-3.235-7.781 0-3.047 1.078-5.625 3.235-7.828 2.156-2.156 4.78-3.235 7.828-3.235 3.047 0 5.672 1.079 7.828 3.235 2.156 2.203 3.234 4.781 3.234 7.828-.046 3.047-1.124 5.672-3.28 7.78-2.157 2.157-4.735 3.235-7.781 3.235H12.5Zm.468-11.204 3.704 3.703c.094.047.14.187.14.328 0 .328-.14.469-.468.469a.425.425 0 0 1-.328-.141l-3.844-3.844a.425.425 0 0 1-.14-.328V6.734c0-.328.14-.469.468-.469s.468.141.468.469v5.578Z' />
);

export const viewBox = '0 0 25 25';
